<template>
  <Form :ref="'form' + current" :model="form" :rules="rules" :label-width="180">
    <Divider orientation="left">申请人基本信息</Divider>
    <Row :gutter="16">
      <Col span="12">
      <FormItem label="上传申请人身份证人像面" prop="applicantIDCardFrontGuid">
        <Row :gutter="16">
          <Col span="24">
          <div class="line_area">
            <div>
              <Upload type="drag" class="uploadImage" :max-size="5120" :on-exceeded-size="handleMaxSize" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'applicantIDCardFrontGuidProgress')"
                :show-upload-list="false" :accept="accept" :format="format" :data="uploadData" :on-success="
                    (response, file, fileList) =>
                     {$refs['applicantIDCardFrontGuidProgress'].updateShow(false)
        $refs['applicantIDCardFrontGuidProgressUpload'].style.display = 'block'; handleSuccess(
                        response,
                        file,
                        fileList,
                        'applicantIDCardFrontGuid',false,'idCard',[{name:'applicantName'},{idCard:'applicantIDCardNo'}]
                      )}
                  " :on-format-error="handleFormatError" :action="$baseURL + '/common/file/uploadfile'">
                <div class="uploadBg">
                  <span ref="applicantIDCardFrontGuidProgressUpload">
                    <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                    <div class="upload_btn">
                      <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                    </div>
                    <div class="upload_btn" @click.stop="openQrCodeUpload('applicantIDCardFrontGuid',false,'idCard',[{name:'applicantName'},{idCard:'applicantIDCardNo'}])">
                      <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                    </div>
                  </span>
                  <progress-bar ref="applicantIDCardFrontGuidProgress"></progress-bar>
                </div>
              </Upload>

            </div>
            <!-- 已上传图片 -->
            <div class="fileList" v-if="form.applicantIDCardFrontGuid">
              <span class="pos">
                <img class="img uploadImage" :src="
                        $baseURL +
                        '/file/cover/' +
                        form.applicantIDCardFrontGuid
                      " />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantIDCardFrontGuid)" type="ios-eye" />
                  <Icon size="26" class="ico" color="#ffffff" @click="
                          handleRemove(
                            0,
                            form.applicantIDCardFrontGuid,
                            'applicantIDCardFrontGuid'
                          )
                        " type="ios-trash-outline" />
                </i>
              </span>
            </div>
            <div class="fileList" v-else>
              <span class="pos">
                <span class="img">
                  <span class="uploadImageNo">
                    <Icon type="ios-image" size="30" />
                  </span>
                </span>
              </span>
            </div>
          </div>
          </Col>
        </Row>
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label="上传申请人身份证国徽面" prop="applicantIDCardBackGuid">
        <Row :gutter="16">
          <Col span="24">
          <div class="line_area">
            <Upload multiple type="drag" ref="applicantIDCardBackGuid" :data="{readIdbackAfterUploaded: true}" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'applicantIDCardBackGuidProgress')"
              class="uploadImage" :accept="accept" :format="format" :show-upload-list="false" :on-success="
                    (response, file, fileList) =>
                     {$refs['applicantIDCardBackGuidProgress'].updateShow(false)
        $refs['applicantIDCardBackGuidProgressUpload'].style.display = 'block'; handleSuccess(
                        response,
                        file,
                        fileList,
                        'applicantIDCardBackGuid',false,'idcard_back'
                      )}
                  " :on-format-error="handleFormatError" :action="$baseURL + '/common/file/uploadfile'">
              <div class="uploadBg">
                <span ref="applicantIDCardBackGuidProgressUpload">
                  <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                  <div class="upload_btn">
                    <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                  </div>
                  <div class="upload_btn" @click.stop="openQrCodeUpload('applicantIDCardBackGuid',false,'idcard_back')">
                    <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                  </div>
                </span>
                <progress-bar ref="applicantIDCardBackGuidProgress"></progress-bar>
              </div>
            </Upload>
            <!-- 已上传图片 -->
            <div class="fileList" v-if="form.applicantIDCardBackGuid">
              <span class="pos">
                <img class="img uploadImage" :src="
                        $baseURL + '/file/cover/' + form.applicantIDCardBackGuid
                      " />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantIDCardBackGuid)" type="ios-eye" />
                  <Icon size="26" class="ico" color="#ffffff" @click="
                          handleRemove(
                            0,
                            form.applicantIDCardBackGuid,
                            'applicantIDCardBackGuid'
                          )
                        " type="ios-trash-outline" />
                </i>
              </span>
            </div>
            <div class="fileList" v-else>
              <span class="pos">
                <span class="img">
                  <span class="uploadImageNo">
                    <Icon type="ios-image" size="30" />
                  </span>
                </span>
              </span>
            </div>
          </div>
          </Col>
        </Row>
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label="申请人姓名" prop="applicantName">
        <Input v-model.trim="form.applicantName" disabled :maxlength="20" placeholder="上传身份证人像面自动识别"></Input>
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label="申请人身份证号" prop="applicantIDCardNo">
        <Input v-model.trim="form.applicantIDCardNo" disabled :maxlength="20" placeholder="上传身份证人像面自动识别"></Input>
      </FormItem>
      </Col>
      <Col span="24">
      <FormItem label="户籍类型" prop="applicantRegisteredResidenceType">
        <RadioGroup v-model.trim="form.applicantRegisteredResidenceType">
          <Radio :label="value" v-for="{text,value} in $store.state.materiaBasicData.registeredResidenceType" :key="value">{{text}}</Radio>
        </RadioGroup>
      </FormItem>
      </Col>
      <Col span="24" v-if="form.applicantRegisteredResidenceType===$store.state.registeredResidenceType['集体户口']">
      <FormItem label="集体户口类型" prop="applicantCollectiveAccountMaterialsType">
        <RadioGroup v-model.trim="form.applicantCollectiveAccountMaterialsType">
          <Radio :label="value" v-for="{text,value} in $store.state.materiaBasicData.collectiveAccountMaterialsTypes" :key="value">{{text}}</Radio>
        </RadioGroup>
      </FormItem>
      </Col>
      <template
        v-if="form.applicantRegisteredResidenceType===$store.state.registeredResidenceType['家庭户口']||(form.applicantRegisteredResidenceType===$store.state.registeredResidenceType['集体户口']&&form.applicantCollectiveAccountMaterialsType===$store.state.collectiveAccountMaterialsTypes['户口簿'])">
        <Col span="12">
        <FormItem label="上传户口簿详细地址页的首页" prop="applicantResidenceBookletMainPageGuid">
          <Row :gutter="16">
            <Col span="24">
            <div class="line_area">
              <Upload multiple type="drag" class="uploadImage" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'applicantResidenceBookletMainPageGuidProgress')" :accept="accept" :format='format'
                :show-upload-list='false' :on-success="(response, file, fileList)=>{$refs['applicantResidenceBookletMainPageGuidProgress'].updateShow(false)
        $refs['applicantResidenceBookletMainPageGuidProgressUpload'].style.display = 'block';handleSuccess(response, file, fileList,'applicantResidenceBookletMainPageGuid')}" :on-format-error="handleFormatError"
                :action="$baseURL+'/common/file/uploadfile'">
                <div class="uploadBg">
                  <span ref="applicantResidenceBookletMainPageGuidProgressUpload">
                    <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                    <div class="upload_btn">
                      <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                    </div>
                    <div class="upload_btn" @click.stop="openQrCodeUpload('applicantResidenceBookletMainPageGuid')">
                      <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                    </div>
                  </span>
                  <progress-bar ref="applicantResidenceBookletMainPageGuidProgress"></progress-bar>

                </div>
              </Upload>
              <!-- 已上传图片 -->
              <div class="fileList" v-if="form.applicantResidenceBookletMainPageGuid">
                <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                <span class="pos">
                  <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.applicantResidenceBookletMainPageGuid" />
                  <i class="img_magnify">
                    <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantResidenceBookletMainPageGuid)" type="ios-eye" />

                    <Icon size="26" class="ico" color="#ffffff" @click="handleRemove(0,form.applicantResidenceBookletMainPageGuid,'applicantResidenceBookletMainPageGuid')" type="ios-trash-outline" />
                  </i>
                </span>
                <!-- </template> -->
              </div>
              <div class="fileList" v-else>
                <span class="pos">
                  <span class="img">
                    <span class="uploadImageNo">
                      <Icon type="ios-image" size="30" />
                    </span>
                  </span>
                </span>
              </div>
            </div>
            </Col>
          </Row>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem label="上传户口簿本人信息页" prop="applicantResidenceBookletSelfPageGuid">
          <Row :gutter="16">
            <Col span="24">
            <div class="line_area">
              <Upload multiple type="drag" class="uploadImage" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'applicantResidenceBookletSelfPageGuidProgress')" :accept="accept" :format='format'
                :show-upload-list='false' :on-success="(response, file, fileList)=>{$refs['applicantResidenceBookletSelfPageGuidProgress'].updateShow(false)
        $refs['applicantResidenceBookletSelfPageGuidProgressUpload'].style.display = 'block';handleSuccess(response, file, fileList,'applicantResidenceBookletSelfPageGuid')}" :on-format-error="handleFormatError"
                :action="$baseURL+'/common/file/uploadfile'">
                <div class="uploadBg">
                  <span ref="applicantResidenceBookletSelfPageGuidProgressUpload">
                    <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                    <div class="upload_btn">
                      <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                    </div>
                    <div class="upload_btn" @click.stop="openQrCodeUpload('applicantResidenceBookletSelfPageGuid')">
                      <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                    </div>
                  </span>
                  <progress-bar ref="applicantResidenceBookletSelfPageGuidProgress"></progress-bar>

                </div>
              </Upload>
              <div class="fileList" v-if="form.applicantResidenceBookletSelfPageGuid">
                <span class="pos">
                  <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.applicantResidenceBookletSelfPageGuid" />
                  <i class="img_magnify">
                    <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantResidenceBookletSelfPageGuid)" type="ios-eye" />
                    <Icon size="26" class="ico" color="#ffffff" @click="handleRemove(0,form.applicantResidenceBookletSelfPageGuid,'applicantResidenceBookletSelfPageGuid')" type="ios-trash-outline" />
                  </i>
                </span>
              </div>
              <div class="fileList" v-else>
                <span class="pos">
                  <span class="img">
                    <span class="uploadImageNo">
                      <Icon type="ios-image" size="30" />
                    </span>
                  </span>
                </span>
              </div>
            </div>
            </Col>
          </Row>
        </FormItem>
        </Col>
      </template>
      <template v-if="form.applicantRegisteredResidenceType===$store.state.registeredResidenceType['集体户口']&&form.applicantCollectiveAccountMaterialsType===$store.state.collectiveAccountMaterialsTypes['派出所出具的户籍证明']">
        <Col span="12">
        <FormItem label="派出所出具的户籍证明" prop="applicantPoliceStationRegistrationCertificateGuid">
          <Row :gutter="16">
            <Col span="24">
            <div class="line_area">
              <Upload multiple type="drag" class="uploadImage" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'applicantPoliceStationRegistrationCertificateGuidProgress')" :accept="accept" :format='format'
                :show-upload-list='false' :on-success="(response, file, fileList)=>{$refs['applicantPoliceStationRegistrationCertificateGuidProgress'].updateShow(false)
        $refs['applicantPoliceStationRegistrationCertificateGuidProgressUpload'].style.display = 'block';handleSuccess(response, file, fileList,'applicantPoliceStationRegistrationCertificateGuid')}" :on-format-error="handleFormatError"
                :action="$baseURL+'/common/file/uploadfile'">
                <div class="uploadBg">
                  <span ref="applicantPoliceStationRegistrationCertificateGuidProgressUpload">
                    <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                    <div class="upload_btn">
                      <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                    </div>
                    <div class="upload_btn" @click.stop="openQrCodeUpload('applicantPoliceStationRegistrationCertificateGuid')">
                      <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                    </div>
                  </span>
                  <progress-bar ref="applicantPoliceStationRegistrationCertificateGuidProgress"></progress-bar>

                </div>
              </Upload>
              <!-- 已上传图片 -->
              <div class="fileList" v-if="form.applicantPoliceStationRegistrationCertificateGuid">
                <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                <span class="pos">
                  <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.applicantPoliceStationRegistrationCertificateGuid" />
                  <i class="img_magnify">
                    <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantPoliceStationRegistrationCertificateGuid)" type="ios-eye" />

                    <Icon size="26" class="ico" color="#ffffff" @click="handleRemove(0,form.applicantPoliceStationRegistrationCertificateGuid,'applicantPoliceStationRegistrationCertificateGuid')" type="ios-trash-outline" />
                  </i>
                </span>
                <!-- </template> -->
              </div>
              <div class="fileList" v-else>
                <span class="pos">
                  <span class="img">
                    <span class="uploadImageNo">
                      <Icon type="ios-image" size="30" />
                    </span>
                  </span>
                </span>
              </div>
            </div>
            </Col>
          </Row>
        </FormItem>
        </Col>
      </template>

      <Col span="24">
      <FormItem label="申请人联系方式" prop="applicantPhone">
        <Input v-model.trim="form.applicantPhone" :maxlength="40" type="number" placeholder="请填写"></Input>
      </FormItem>
      </Col>
      <Col span="24">
      <FormItem label="上传申请人居住证正面" prop="applicantResidencePermitFrontGuid">
        <Row :gutter="16">
          <Col span="24">
          <div class="line_area">
            <Upload multiple type="drag" class="uploadImage" :max-size="5120" :on-exceeded-size="handleMaxSize" :accept="accept" :format="format" :data="{readResidencePermit:true,}"
              :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'applicantResidencePermitFrontGuidProgress')" :show-upload-list="false" :on-success="
                    (response, file, fileList) =>
                    {  $refs['applicantResidencePermitFrontGuidProgress'].updateShow(false)
        $refs['applicantResidencePermitFrontGuidProgressUpload'].style.display = 'block';handleSuccess(
                        response,
                        file,
                        fileList,
                        'applicantResidencePermitFrontGuid',false,'residencePermit',[{residencePermitExpiryDate:'applicantResidencePermitExpiryDate'}]
                      )}
                  " :on-format-error="handleFormatError" :action="$baseURL + '/common/file/uploadfile'">
              <div class="uploadBg">
                <span ref="applicantResidencePermitFrontGuidProgressUpload">
                  <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                  <div class="upload_btn">
                    <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                  </div>
                  <div class="upload_btn" @click.stop="openQrCodeUpload('applicantResidencePermitFrontGuid',false,'residencePermit',[{residencePermitExpiryDate:'applicantResidencePermitExpiryDate'}])">
                    <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                  </div>
                </span>
                <progress-bar ref="applicantResidencePermitFrontGuidProgress"></progress-bar>
              </div>
            </Upload>
            <!-- 已上传图片 -->
            <div class="fileList" v-if="form.applicantResidencePermitFrontGuid">
              <span class="pos">
                <img class="img uploadImage" :src="
                        $baseURL +
                        '/file/cover/' +
                        form.applicantResidencePermitFrontGuid
                      " />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantResidencePermitFrontGuid)" type="ios-eye" />
                  <Icon size="26" class="ico" color="#ffffff" @click="
                          handleRemove(
                            0,
                            form.applicantResidencePermitFrontGuid,
                            'applicantResidencePermitFrontGuid'
                          )
                        " type="ios-trash-outline" />
                </i>
              </span>
            </div>
            <div class="fileList" v-else>
              <span class="pos">
                <span class="img">
                  <span class="uploadImageNo">
                    <Icon type="ios-image" size="30" />
                  </span>
                </span>
              </span>
            </div>
          </div>
          </Col>
        </Row>
      </FormItem>
      </Col>
      <!-- <Col span="12">
      <FormItem label="上传申请人居住证反面" prop="applicantResidencePermitBackGuid">
        <Row :gutter="16">
          <Col span="24">
          <div class="line_area">
            <Upload multiple type="drag" class="uploadImage" :accept="accept" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'applicantResidencePermitBackGuidProgress')" :format="format"
              :show-upload-list="false" :on-success="
                    (response, file, fileList) =>
                      {$refs['applicantResidencePermitBackGuidProgress'].updateShow(false)
        $refs['applicantResidencePermitBackGuidProgressUpload'].style.display = 'block';handleSuccess(
                        response,
                        file,
                        fileList,
                        'applicantResidencePermitBackGuid'
                      )}
                  " :on-format-error="handleFormatError" :action="$baseURL + '/common/file/uploadfile'">
              <div class="uploadBg">
                <span ref="applicantResidencePermitBackGuidProgressUpload">
                  <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                  <div class="upload_btn">
                    <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                  </div>
                  <div class="upload_btn" @click.stop="openQrCodeUpload('applicantResidencePermitBackGuid')">
                    <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                  </div>
                </span>
                <progress-bar ref="applicantResidencePermitBackGuidProgress"></progress-bar>
              </div>
            </Upload>
            <div class="fileList" v-if="form.applicantResidencePermitBackGuid">
              <span class="pos">
                <img class="img uploadImage" :src="
                        $baseURL +
                        '/file/cover/' +
                        form.applicantResidencePermitBackGuid
                      " />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantResidencePermitBackGuid)" type="ios-eye" />
                  <Icon size="26" class="ico" color="#ffffff" @click="
                          handleRemove(
                            0,
                            form.applicantResidencePermitBackGuid,
                            'applicantResidencePermitBackGuid'
                          )
                        " type="ios-trash-outline" />
                </i>
              </span>
            </div>
            <div class="fileList" v-else>
              <span class="pos">
                <span class="img">
                  <span class="uploadImageNo">
                    <Icon type="ios-image" size="30" />
                  </span>
                </span>
              </span>
            </div>
          </div>
          </Col>
        </Row>
      </FormItem>
      </Col> -->
      <Col span="12">
      <FormItem label="居住证截止时间" prop="applicantResidencePermitExpiryDate">
        <DatePicker type="date" disabled v-model="form.applicantResidencePermitExpiryDate" placeholder="上传居住证正面自动识别" style="width: 100%" />
      </FormItem>
      </Col>

      <template>
        <Col span="24">
        <FormItem label="添加同住人" prop="isSpouseEnjoyTreatment" :required="true">
          <Checkbox v-model.trim="form.isSpouseEnjoyTreatment" label="配偶">配偶</Checkbox>
          <Checkbox v-model.trim="form.isChildrenEnjoyTreatment" label="子女">子女</Checkbox>
        </FormItem>
        </Col>
      </template>

    </Row>
    <div class="bom_btn">
      <div>
        <Button @click="next('form' + current, current_index - 1)">上一步</Button>
        <Button type="warning" @click="submitStore()">暂存</Button>
        <Button type="primary" @click="next('form' + current, current)">下一步</Button>
      </div>
    </div>
  </Form>
</template>
<script>
export default {
  props: {
    form: { type: Object },
    current: { type: Number },
    hasLaborDispatchPermit: { type: Boolean },
  },
  data() {
    return {
      format: ['jpg', 'png', 'jpeg'],
      accept: 'image/*',
      //   form: { id: 'ywlsh_12356789', kh: '新开户', sfzzm: [] },
      uploadData: { readIdInfo: true },
      //   ywlbList: [
      //     {
      //       name: '积分新办：年龄+教育背景（高于或等于本科学士）+社保年限',
      //       value: '积分新办：年龄+教育背景（高于或等于本科学士）+社保年限',
      //     },
      //   ],
      appInfoDataType: this.$store.state.appInfoDataType,
      current_index: this.current,

      rules: {
        personnelPhone: [{ required: true, message: '请输入', trigger: 'change' }],
        applicantIDCardFrontGuid: [{ required: true, message: '请上传', trigger: 'change' }],
        applicantIDCardBackGuid: [{ required: true, message: '请上传', trigger: 'change' }],
        applicantName: [{ required: true, message: '请输入', trigger: 'change' }],
        applicantIDCardNo: [
          { required: true, message: '请输入', trigger: 'change' },

          {
            pattern:
              /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
            message: '请输入正确的身份证号',
            trigger: 'blur',
          },
        ],
        isSpouseEnjoyTreatment: [
          {
            validator: (rule, value, callback) => {
              if (this.form.isSpouseEnjoyTreatment || this.form.isChildrenEnjoyTreatment) {
                callback()
              } else {
                callback(new Error('请选择'))
              }
            },
            trigger: 'change',
          },
        ],
        applicantPhone: [
          { required: true, message: '请输入', trigger: 'change' },
          {
            pattern: /^[0-9]+$/,
            message: '请输入正确的联系方式',
            trigger: 'change',
          },
        ],
        applicantResidencePermitFrontGuid: [
          { required: true, message: '请上传', trigger: 'change' },
        ],
        dispatchAgreementGuidList: [
          { required: true, message: '请上传', trigger: 'change', type: 'array' },
        ],
        applicantTaxPaymentCertificateGuidList: [
          { required: true, message: '请上传', trigger: 'change', type: 'array' },
        ],
        applicantRegisteredResidenceType: [
          { required: true, message: '请选择', type: 'number', trigger: 'change' },
        ],
        applicantCollectiveAccountMaterialsType: [
          { required: true, message: '请选择', type: 'number', trigger: 'change' },
        ],
        applicantResidenceBookletMainPageGuid: [
          { required: true, message: '请上传', trigger: 'change' },
        ],
        applicantResidenceBookletSelfPageGuid: [
          { required: true, message: '请上传', trigger: 'change' },
        ],
        applicantPoliceStationRegistrationCertificateGuid: [
          { required: true, message: '请上传', trigger: 'change' },
        ],
        laborContractGuidList: [
          { required: true, message: '请上传', trigger: 'change', type: 'array' },
        ],
        hasLaborDispatchPermit: [
          { required: true, message: '请选择', type: 'boolean', trigger: 'change' },
        ],
        acceptanceCenter: [{ required: true, message: '请选择', trigger: 'change' }],
        hasEducation: [{ required: true, message: '请选择', type: 'boolean', trigger: 'change' }],
        jobAgreementGuidList: [
          { required: true, message: '请上传', trigger: 'change', type: 'array' },
        ],
        applicantResidencePermitBackGuid: [
          { required: true, message: '请上传', trigger: 'change' },
        ],
        applicantResidencePermitExpiryDate: [
          {
            required: true,
            message: '请选择',
            type: 'date',
            trigger: 'change',
          },
        ],
        hasPersonFiles: [
          {
            required: true,
            message: '请选择',
            type: 'boolean',
            trigger: 'change',
          },
        ],
        isSpouseRegisteredResidenceInSH: [
          {
            required: true,
            message: '请选择',
            type: 'boolean',
            trigger: 'change',
          },
        ],
        declarationItems: [{ required: true, message: '请输入', trigger: 'change' }],
      },
      clList: ['rl', 'dw', 'yy', 'sh', 'rl'],
      selectList: [
        { name: '是', value: 1 },
        { name: '否', value: 0 },
      ],
    }
  },
  methods: {
    //下一步
    next(name, val) {
      //   this.$Message.success('Success!')
      let _this = this
      if (val < this.current) {
        this.$emit('next', _this.appInfoDataType['单位基本信息'])
        return
      }

      this.$refs[name].validate(async (valid) => {
        if (!valid) {
          this.$Message.error('请将信息填写完整')
          return
        }

        console.log('🚀 ~ file: index.vue:267 ~ this.$refs[name].validate ~ this.form:', this.form)
        let submiteUrl = `/api/services/app/TJTZRApi/SaveAppApplicantInfo`

        if (this.form.isSpouseEnjoyTreatment) {
          _this.$emit('next', _this.appInfoDataType['配偶信息'], submiteUrl)
          return
        }
        if (this.form.isChildrenEnjoyTreatment) {
          _this.$emit('next', _this.appInfoDataType['子女信息'], submiteUrl)
          return
        }
      })
    },
    async submitStore() {
      await this.$emit('submit', '/api/services/app/TJTZRApi/SaveAppApplicantInfo', 0, '保存成功')
    },
    //文件大小超出
    handleMaxSize(file) {
      this.$emit('handleMaxSize', file)
    },
    //移除文件
    async handleRemove(file, fileList, property, isArray) {
      this.$emit('handleRemove', file, fileList, property, isArray)
    },
    //文件上传成功
    handleSuccess(response, file, fileList, property, isArray, isReadInfo, readIdInfoAfterToView) {
      this.$emit(
        'handleSuccess',
        response,
        file,
        fileList,
        property,
        isArray,
        isReadInfo,
        readIdInfoAfterToView
      )
    },
    //文件格式错误
    handleFormatError(file) {
      this.$emit('handleFormatError', file)
    },
    //上传前 用于单个上传清空上传列表
    handleBefore(property) {
      //不为数组时传一个删一个列表
      this.$refs[property].clearFiles()
    },
    //预览
    handleView(guid) {
      this.$emit('handleView', guid)
    },
    //文件预览
    handlePreview(file) {
      this.$emit('handlePreview', file)
    },
    //时间格式化
    changeDateFmt(dateFmt, date, property) {
      this.$emit('changeDateFmt', dateFmt, date, property)
    },
    openQrCodeUpload(property, isArray, isReadInfo, readIdInfoAfterToView) {
      this.$emit('openQrCodeUpload', property, isArray, isReadInfo, readIdInfoAfterToView)
    },
    //户籍改变
    isSpouseRegisteredResidenceInSHChange(e) {},
    //
    updateProgress(event, file, fileList, name) {
      // this.percent = fileInfo.percent * 0.01
      this.$refs[name + 'Upload'].style.display = 'none'
      this.$refs[name].updateShow(true)
      this.$refs[name].updateProgress(Math.round(event.percent)) //=fileInfo.percent * 0.01

      this.$refs[name + 'Upload'].show = event.percent == 100
      // if (event.percent == 100) {
      //   this.$refs[name].updateShow(false)
      //   this.$refs[name + 'Upload'].style.display = 'block'
      // }
    },
  },
}
</script>